package demos.`fun`

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.geometry.center
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.graphics.drawscope.rotate
import kotlin.math.min


const val ANDROID_LOGO = "083830c2e2c31955f5b9583ded81b710d7bc8cd19fb977a32d4b978c781964d2"

@Composable
fun AndroidLogo() {
    Canvas(
        Modifier.fillMaxSize()
    ) {
        val length = min(size.width, size.height)
        val diameter = length / 3
        val eyeRadius = diameter / 20

        val antennaPath = Path()
        antennaPath.moveTo(size.center.x, size.center.y - 10f)
        antennaPath.relativeLineTo(0f, -diameter * .6f)

        drawArc(
            color = Color.Green,
            startAngle = 0f,
            sweepAngle = -180f,
            useCenter = true,
            topLeft = size.center - Offset(diameter / 2, diameter / 2),
            size = Size(diameter, diameter)
        )

        rotate(30f) {
            drawPath(
                path = antennaPath,
                color = Color.Green,
                style = Stroke(
                    width = 10f,
                    cap = StrokeCap.Round,
                )
            )
        }

        rotate(-30f) {
            drawPath(
                path = antennaPath,
                color = Color.Green,
                style = Stroke(
                    width = 10f,
                    cap = StrokeCap.Round,
                )
            )
        }

        drawCircle(
            color = Color.Black,
            radius = eyeRadius,
            center = size.center - Offset(diameter / 5, diameter / 4)
        )

        drawCircle(
            color = Color.Black,
            radius = eyeRadius,
            center = size.center - Offset(-diameter / 5, diameter / 4)
        )


    }
}